import { useStaticQuery, graphql, Link } from 'gatsby';
import * as React from 'react';
import styled from 'styled-components';
import SearchContext from '../../contexts/SearchContext';

const Wrapper = styled.div`
  img {
    display: block;
    width: 100%;
    height: auto;
    max-width: 110px;
    max-height: 40px;
  }

  a:focus-visible {
    img {
      outline: auto;
      outline-color: var(--earth-fm--color--blue);
    }
  }
`;

interface Props {
  lazyLoading?: boolean;
}

export default function SiteLogo({ lazyLoading = false }: Props) {
  const { setIsSearchOpen, setIsShowingFilters } = React.useContext(SearchContext);

  const data = useStaticQuery<Queries.SiteLogoQuery>(graphql`
    query SiteLogo {
      wp {
        themeGeneralSettings {
          themeOptions {
            general {
              siteLogo {
                localFile {
                  publicURL
                }
              }
            }
          }
        }
      }
    }
  `);

  const handleClick = React.useCallback(() => {
    setIsSearchOpen(false);
    setIsShowingFilters(false);
  }, [setIsSearchOpen, setIsShowingFilters]);

  return (
    <Wrapper>
      <Link to="/" onClick={handleClick}>
        {data.wp?.themeGeneralSettings?.themeOptions?.general?.siteLogo?.localFile?.publicURL && (
          <img
            src={data.wp.themeGeneralSettings.themeOptions.general.siteLogo.localFile.publicURL}
            alt="Earth.fm logo"
            loading={lazyLoading ? 'lazy' : undefined}
          />
        )}
      </Link>
    </Wrapper>
  );
}
